var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigateTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 4.33301V12.333H10.6667V4.33301H1.33333ZM1.33333 2.99967H10.6667V1.66634H1.33333V2.99967ZM11.3333 13.6663H0.666667C0.489856 13.6663 0.320286 13.5961 0.195262 13.4711C0.0702379 13.3461 0 13.1765 0 12.9997V0.999674C0 0.822863 0.0702379 0.653294 0.195262 0.52827C0.320286 0.403246 0.489856 0.333008 0.666667 0.333008H11.3333C11.5101 0.333008 11.6797 0.403246 11.8047 0.52827C11.9298 0.653294 12 0.822863 12 0.999674V12.9997C12 13.1765 11.9298 13.3461 11.8047 13.4711C11.6797 13.5961 11.5101 13.6663 11.3333 13.6663ZM2.66667 5.66634H5.33333V8.33301H2.66667V5.66634ZM2.66667 9.66634H9.33333V10.9997H2.66667V9.66634ZM6.66667 6.33301H9.33333V7.66634H6.66667V6.33301Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateTo);
export default __webpack_public_path__ + "static/media/navigateTo.950477911c52b58e1babcd4bf3d84970.svg";
export { ForwardRef as ReactComponent };